import { FormData, FormValue } from './is-form-empty.model';

export function isFormEmpty(
  checkedObject: FormValue[] | FormValue | FormData | FormData[],
): boolean {
  let isObjectEmptyResult = true;

  if (typeof checkedObject !== 'undefined' && checkedObject !== null) {
    if (Array.isArray(checkedObject)) {
      isObjectEmptyResult = (checkedObject as (FormValue | FormData)[]).every(
        (checkedValue) => isFormEmpty(checkedValue),
      );
    } else if (typeof checkedObject === 'object') {
      const objectKeys = Object.getOwnPropertyNames(checkedObject);

      isObjectEmptyResult = objectKeys.every((controlKey) =>
        isFormEmpty(checkedObject[controlKey]),
      );
    } else {
      isObjectEmptyResult = !checkedObject;
    }
  }

  return isObjectEmptyResult;
}
